export default {
  default: "Layout.vue",
  login: "LayoutStart.vue",
  noSidebar: "LayoutNoSidebar.vue",
};
